"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WeChatIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../helpers");

var _Icon = require("./Icon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** WeChatIcon */
var WeChatIcon =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WeChatIcon, _React$Component);

  function WeChatIcon(props) {
    var _this;

    _classCallCheck(this, WeChatIcon);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WeChatIcon).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function () {
      _this.setState({
        hover: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
      _this.setState({
        hover: false
      });
    });

    _this.state = {
      hover: false
    };
    return _this;
  }

  _createClass(WeChatIcon, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(WeChatContainer, {
        href: "http://weixin.qq.com/r/2CotNbbES_s0rfJW93-K"
      }, _react.default.createElement(_Icon.Icon, _extends({
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        viewBox: "0 0 18 18"
      }, this.props), _react.default.createElement(_Icon.Title, null, "WeChat"), _react.default.createElement(_Icon.Path, {
        d: "M14.543 13.223c.889-.645 1.457-1.597 1.457-2.657 0-1.94-1.888-3.513-4.217-3.513-2.329 0-4.217 1.573-4.217 3.513 0 1.941 1.888 3.514 4.217 3.514.481 0 .946-.068 1.377-.192l.123-.019c.082 0 .155.025.224.065l.924.533.08.026a.14.14 0 0 0 .142-.14l-.023-.103-.19-.709-.015-.09a.28.28 0 0 1 .118-.228zM7.06 3.173C4.266 3.173 2 5.061 2 7.39c0 1.27.681 2.415 1.748 3.188.086.06.142.16.142.274l-.018.108-.228.85-.027.123c0 .094.076.17.169.17l.098-.032 1.107-.64a.53.53 0 0 1 .269-.078l.148.023a5.984 5.984 0 0 0 1.652.231l.278-.007a3.259 3.259 0 0 1-.17-1.033c0-2.124 2.066-3.846 4.615-3.846l.275.007c-.381-2.014-2.473-3.555-4.998-3.555zm3.317 6.832a.562.562 0 1 1 .001-1.125.562.562 0 0 1 0 1.125zm2.812 0a.562.562 0 1 1 0-1.125.562.562 0 0 1 0 1.125zm-7.816-3.29a.674.674 0 1 1 0-1.348.674.674 0 0 1 0 1.348zm3.374 0a.674.674 0 1 1 0-1.348.674.674 0 0 1 0 1.348z",
        fill: (0, _helpers.color)(this.props.fill),
        fillRule: "evenodd"
      })), this.state.hover && _react.default.createElement(QRToolTip, null, _react.default.createElement("img", {
        src: "http://files.artsy.net/images/wechat_qr_logo.png"
      })));
    }
  }]);

  return WeChatIcon;
}(_react.default.Component);

exports.WeChatIcon = WeChatIcon;
WeChatIcon.displayName = "WeChatIcon";
var QR_SIZE = 125;
var QR_PADDING = (0, _helpers.space)(2);
var QR_CONTAINER_SIZE = QR_SIZE + QR_PADDING * 2;

var QRToolTip = _styledComponents.default.div.withConfig({
  displayName: "WeChatIcon__QRToolTip",
  componentId: "bi7h39-0"
})(["position:absolute;bottom:calc(100% + ", "px);width:", "px;height:", "px;right:", "px;border:1px solid ", ";padding:", "px;background-color:white;box-shadow:0 10px 20px ", ";&::after{content:\" \";position:absolute;width:0;height:0;border-left:8px solid transparent;border-right:8px solid transparent;border-top:10px solid white;bottom:-9px;right:calc(50% - 8px);}img{width:", ";height:", ";}"], (0, _helpers.space)(2), QR_CONTAINER_SIZE, QR_CONTAINER_SIZE, -1 * QR_SIZE / 2, (0, _helpers.color)("black10"), QR_PADDING, (0, _helpers.color)("black10"), QR_SIZE, QR_SIZE);

var WeChatContainer = _styledComponents.default.a.withConfig({
  displayName: "WeChatIcon__WeChatContainer",
  componentId: "bi7h39-1"
})(["position:relative;cursor:pointer;"]);
//# sourceMappingURL=WeChatIcon.js.map